import React ,{useEffect,useState} from "react";
import Card from "./AssetCard";
import axios from "axios";
import { MdChevronRight, MdChevronLeft } from "react-icons/md";

import Button from '@mui/material/Button';
import './AssetRow.css';
import { json } from "react-router-dom";
import { ConnectContactLens } from "aws-sdk";
var config = require("../../src/config/dev").default;




// Returns true if an NFT + one of its sale entries matches the search query
function matchesSearch(nft, sale, query) {
  if (!query || query.trim() === "") return true;
  const q = query.toLowerCase().trim();
  return (
    (nft.assetName   || "").toLowerCase().includes(q) ||
    (nft.assetId     || "").toString().toLowerCase().includes(q) ||
    (nft.tokenId     || "").toString().toLowerCase().includes(q) ||
    (nft.network_type|| "").toLowerCase().includes(q) ||
    (sale.ownerName  || "").toLowerCase().includes(q) ||
    (sale.fixedPrice || "").toString().toLowerCase().includes(q)
  );
}

function Rows(props){
    var coll = document.getElementsByClassName("collapsible");
    var i;
  
    for (i = 0; i < coll.length; i++) {
      
      coll[i].addEventListener("click", function() {
        this.classList.toggle("active1");
        var content = this.nextElementSibling;
        if (content.style.display === "block") {
          content.style.display = "none";
        } else {
          content.style.display = "block";
        }
        if (content.style.maxHeight){
                content.style.maxHeight = null;
              } else {
                content.style.maxHeight = content.scrollHeight + "px";
              } 
      });
    }

    //const [products,setProducts] = useState([]);
    
    const [viewnfts,setviewNfts] = useState([]);
    const [isChecked, setIsChecked] = useState([]);
    const [isCheckedAlgo, setIsCheckedAlgo] = useState(false);
    const [isCheckedPolygon, setIsCheckedPolygon] = useState(false);
    // const [network_type,setNetworkType] = useState();
    // const [queryParams,setqueryParams] = useState();
    const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
    const [nfts,setNfts] = useState([]);
    const [EPRnfts,setEPRNfts] = useState([]);
    // const [nftcopy,setNftcopy] = useState([]);
    const [assetFilterArray,setassetFilterArray] = useState([]);
    const [networkFilterArray,setNetworkFilterArray] = useState([]);
    const [EPRnetworkFilterArray,setEPRNetworkFilterArray] = useState([]);
    let [EPRassetnamefilterArray,setEPRassetnamefilterArray] = useState([]);
    let [EPRassetcategoryfilterArray,setEPRassetcategoryfilterArray] = useState([]);
    const [categoryFilterArray,setcategoryFilterArray] = useState([]);
    const [assetArray,setassetArray] = useState([]);
    const [pricefilterArray,setpricefilterArray] = useState([]);
    const [newArrayTemp , setnewArrayTemp]= useState([]);
    const [ExArray , setExArray]= useState([]);
    const [ArrayAsset , setArrayAsset]= useState([]);
    const [network,setNetwork] = useState([]);
    const [nftsfilter,setNftsFilter] = useState([]);
    // const [nft,setNft] = useState([]);
    
    const [fetch, setFetch] = useState();
    const copy = "";
    const salecopy = "";
    const network_type = "";
    const languages = [];
    const checkboxes = document.querySelectorAll('.checkbox')
    // const [userinfo, setUserInfo] = useState({
    //   languages: [],
    //   response: [],
    // });
    let queryParams = "";
    let queryParams1 = "";
    // const renderassetList = [];
    let dataArray = [];
    let filtersarray = [];
    // let selectedValues=[];
    const [selectedValues, setSelectedValues] = useState({network_type: [], provenanceTemplatePath: [], assetName: []});
    // let selectedValues1=[];
    const [selectedValues1, setSelectedValues1] = useState({network_type: [], assetName: [], assetCategory: []});
    let nft1 = [];
    let processedArray = [];
    let nftcopy = [];
    let totalnfts = [];

    // ── Sidebar toggle state ─────────────────────────────────
    const [sidebarCollapsed, setSidebarCollapsed] = useState(true);
    let salepercopy = [];
    let newSalesArray = [];
    let lastelement = [];
    const uniqueTags = [];
    const uniqueTags1 = [];
    const uniqueTags2 = [];
    const uniqueTags3 = [];
    // let EPRnfts = [];
    // const nftArray = 
    // [
    // {
    //   nft1 : "array1",
    //   nft2 : "array2",
    //   nft3 : "array3",
    // }
    // ]
  //  let nftsfilter = [];
    // const [data, setData] = useState(null);
    let lastassetnamearray = [];
    let assetNameArray= [];
    let assetNameArrayTemp= [];
    let arrayforasset = [];
    let forassetname = [];
    let outputArrayCategory = [];
    let price = [];
    let categoryFilter = [];
    let priceArray = [];
    let outputArrayNetwork = [];
    let EPRoutputArrayNetwork = [];
    let eproutarrayassetname  = [];
    let eproutarrayassetcategory  = [];
    let eprassetnamefilter = [];
    let eprassetcategoryfilter = [];
    let networkFilter = [];
    let EPRnetworkFilter = [];
    let outputArray = [];
    let Ex = [];
    let assetFilter = [];
    const itemList = ["Item1", "Item2", "Item3", "Item4", "Item5"];
  
    function isSameAnswer() {
     if (salepercopy.nft_sale.length) {
        console.log("in function");
        return (salepercopy.nft_sale.length);
      }
    }

    useEffect(()=>{
        

        const fetchNft = async () =>{
        //   const result =  await axios.get(`/eprnftdetails`);
        //   //console.log(result.data[1].normalized_metadata.name)
        //   setProducts(result.data);
        // };
        // await axios.get("/getAccessToken").then((response)=>{
        //   //console.log("access token",response.data);
        //   sessionStorage.setItem('traceChainAccessToken', response.data);
        // });
             console.log("api",config.API_ENDPOINT);
            try {
            await axios.get(config.API_ENDPOINT+'src/v1/nftdetails/nftmarketplace', {

                headers: {
                'X-Api-Token': sessionStorage.getItem("traceChainAccessToken")
                },


            })

            .then((res) => {
              
              console.log("in API",res);
                const nftResult = res.data.data.result;
                nftResult.forEach(async element => { 
                  element.assetType = "NonEprAsset"
                })

                // console.log(nftResult[0].nft_sale[0].sale_copies);
                setNfts(nftResult);
                console.log("nfts148",nfts);
                setNftsFilter(nftResult);
                Ex.push(nftResult);
                setExArray(Ex);
                console.log("137",ExArray);
                // let newArray = nftResult;
                // nftsfilter = newArray;
                console.log("filters",Ex);

                Ex.map ((filters) => {
                  console.log("fil",filters)
                  filters.map((fil1) => {
                     console.log("136",fil1.assetName);
                     assetNameArray.push(fil1.assetName);
                     setnewArrayTemp(assetNameArray);
                    //  newArrayTemp = assetNameArray;
                  })
                  
                })
                console.log("assetNameArray",assetNameArray);
                console.log("newArrayTemp",newArrayTemp);


                nftResult.map((filters) => {
                console.log("filters at 101", filters);
                outputArray.push(filters.assetName);
                
              })
              console.log("outputarray", outputArray);
             
              const assetFilter1 = [...new Set(outputArray)];
              assetFilter.push(assetFilter1);
              setassetFilterArray(assetFilter);
              assetFilterArray.push(assetFilter);
              console.log("assetFilterArray",assetFilterArray);
              // console.log("uniqueValues1",uniqueValues1);
              // const assetFilter = uniqueValues1;
             console.log("assetFilter1",assetFilter1);
              console.log("assetFilter",assetFilter, typeof(assetFilter));
              console.log("nfts==>",nftResult);
              console.log("mapping",nfts);
              console.log("mappingsale",nftResult[0].nft_sale.length);
              console.log("itemList",itemList , typeof(itemList));

              nftResult.map((filters) => {
                console.log("filters at 101", filters);
                outputArrayNetwork.push(filters.network_type);
              })

              console.log("outputarray", outputArrayNetwork)

              const networkFilter1 = [...new Set(outputArrayNetwork)];
              networkFilter.push(networkFilter1);
              setNetworkFilterArray(networkFilter);
              console.log("setntarray",networkFilterArray);
              networkFilterArray.push(networkFilter);
              console.log("networkFilter1",networkFilter1);
              console.log("networkFilter",networkFilter);
              console.log("networkFilterArray",networkFilterArray);


              nftResult.map((filters) => {
                console.log("filters at 101", filters);
                outputArrayCategory.push(filters.provenanceTemplatePath);
              })

              console.log("outputarray", outputArrayCategory)

              const categoryFilter1 = [...new Set(outputArrayCategory)];
              categoryFilter.push(categoryFilter1);
              setcategoryFilterArray(categoryFilter);
              categoryFilterArray.push(categoryFilter);

              console.log("categoryFilter1",categoryFilter1);
              console.log("categoryFilter",categoryFilter);
              console.log("categoryFilterArray",categoryFilterArray);


              nftResult.map((filters) => {
                console.log("187", filters);
                filters.nft_sale.map((filternew) => {
                 console.log("filternew",filternew.fixedPrice);
                 price.push(filternew.fixedPrice);
               })
               
              })

              console.log("pricearray", price);

              const pricefilter = [...new Set(price)];
              priceArray.push(pricefilter);
              setpricefilterArray(priceArray);

             
              console.log("pricefilter",pricefilter);
              console.log("priceArray",priceArray);
              console.log("pricefilterArray",pricefilterArray);

              
              // nftResult.map((filters) => {
              //   console.log("183", filters);
              //   if(filters.provenanceTemplatePath == "Food")
              //   {
              //   Ex.push(filters.assetName);
              //   }
              // })

              // console.log("outputarrayEx", Ex);



              
              nftResult.map((nftcopies) => {
                console.log("nftcopies", nftcopies);
                // const copy1 = nftcopies;
                nftcopy.push(nftcopies);
              })
              console.log("nftcopy",nftcopy);

              nftcopy.map((totalnfts1) => {
                console.log("totalnfts1",totalnfts1);
                totalnfts.push(totalnfts1);
              })
              console.log("totalnfts",totalnfts);



              // console.log("148",totalnfts.map.nft_sale);
              
              totalnfts.map((saleper_copy) => {
                console.log("saleper_copy",saleper_copy);
                console.log("saleper_copynftsale",saleper_copy.nft_sale);
                salepercopy.push(saleper_copy.nft_sale);
                
              // for (var i in salepercopy) 
              // {
              //   console.log("row " + i);
              //   for (var j in salepercopy[i]) 
              //     {
              //       console.log("204" + salepercopy[i][j]);
              //     }
              // }
              // // let result = salepercopy.every();
              // // console.log("result",result);
              })
              console.log("salepercopy",salepercopy);
              // console.log("156",salepercopy.nft_sale);

              salepercopy.map((eachcopy) => {
                console.log("eachcopy",eachcopy); 
                eachcopy.map((array1)=>{
                  console.log("array1",array1); 
                  newSalesArray.push(array1);
                })
              })
              console.log("newSalesArray",newSalesArray);

              // salepercopy.map((eachcopy) => {
              //   console.log("eachcopy",eachcopy); 
              //   newSalesArray.push(eachcopy);
              // })
              // console.log("newSalesArray",newSalesArray)

            });
            } catch (err) {
              console.error("Error loading NFT marketplace data:", err);
              setNfts([]);
              setNftsFilter([]);
            }
        };
        fetchNft();
        // handleFilterChange();
        // removeusingSet();

        const fetchEPRNft = async () =>{

          // await axios.get("/getAccessToken").then((response)=>{

          //   sessionStorage.setItem('traceChainAccessToken', response.data);
          // });
               console.log("api",config.API_ENDPOINT);
              try {
              await axios.get(config.API_ENDPOINT+'src/v1/eprnftdetails/eprnftmarketplace', {

                  headers: {
                  'X-Api-Token': sessionStorage.getItem("traceChainAccessToken")
                  },
                  
  
              })
              
              .then((res) => {
                
                console.log("in EPR API",res);
                  const EPRnftResult = res.data.data.result;
                  EPRnftResult.forEach(async element => { 
                    element.assetType = "EprAsset"
                  })
                  console.log("eprData",EPRnftResult);
                  setEPRNfts(EPRnftResult);
                  // EPRnfts.push(EPRnftResult);
                  console.log("epr348",EPRnfts);
                  console.log("EPRnfts",EPRnfts);

                  EPRnftResult.map((filters) => {
                    console.log("filters at 101", filters);
                    EPRoutputArrayNetwork.push(filters.network_type);
                  })
    
                  console.log("outputarray", EPRoutputArrayNetwork)
    
                  const networkFilter1 = [...new Set(EPRoutputArrayNetwork)];
                  EPRnetworkFilter.push(networkFilter1);
                  setEPRNetworkFilterArray(EPRnetworkFilter);
                  EPRnetworkFilterArray.push(EPRnetworkFilter);
    
                  console.log("eprnetworkFilter1",networkFilter1);
                  console.log("eprnetworkFilter",EPRnetworkFilter);
                  console.log("eprnetworkFilterArray",EPRnetworkFilterArray);


                  EPRnftResult.map((filters) => {
                    console.log("filters at 101", filters);
                    eproutarrayassetname.push(filters.assetName);
                  })
                  
                  console.log("assetnameoutput", eproutarrayassetname);

                  const assetnamefilter1 = [...new Set(eproutarrayassetname)];
                  eprassetnamefilter.push(assetnamefilter1);
                  setEPRassetnamefilterArray(eprassetnamefilter);
                  EPRassetnamefilterArray.push(eprassetnamefilter);
    
                  console.log("assetnamefilter1",assetnamefilter1);
                  console.log("eprassetnamefilter",eprassetnamefilter);
                  console.log("EPRassetnamefilterArray",EPRassetnamefilterArray);


                  EPRnftResult.map((filters) => {
                    console.log("filters at 101", filters);
                    eproutarrayassetcategory.push(filters.assetCategory);
                  })

                  console.log("eproutarrayassetcategory", eproutarrayassetcategory);

                  const assetcategoryfilternew = [...new Set(eproutarrayassetcategory)];
                  // Filter out null values
                 const filteredArray = assetcategoryfilternew.filter(value => value !== null);
                  console.log("filteredArray",filteredArray);
                  // Create a set from the filtered array
                  const assetcategoryfilter1 = [...new Set(filteredArray)];
                  console.log("assetcategoryfilter1",assetcategoryfilter1);
                  console.log("not null",assetcategoryfilter1);
                  
                  eprassetcategoryfilter.push(assetcategoryfilter1);
                  setEPRassetcategoryfilterArray(eprassetcategoryfilter);
                  EPRassetcategoryfilterArray.push(eprassetcategoryfilter);
                  
    
                  console.log("assetcategoryfilter1",assetcategoryfilter1);
                  console.log("eprassetcategoryfilter",eprassetcategoryfilter);
                  console.log("EPRassetcategoryfilterArray",EPRassetcategoryfilterArray)


              })
              } catch (err) {
                console.error("Error loading EPR NFT marketplace data:", err);
                setEPRNfts([]);
              }

          };
          fetchEPRNft();
          // fetchassetNfts(selectedValues);
         
          // handleCheckboxChange();
      },[]);

      
    //   window.addEventListener("beforeunload", (event) => {
    //     fetchNft();
    //     console.log("API call before page reload");
    // });

  //   window.addEventListener("unload", (event) => {
  //     fetchNft();
  //     console.log("API call after page reload");
  // });

      const handleFilterChange = async () => {
        console.log("in filter func()");
        const fetchNft = await axios.get(config.API_ENDPOINT+'src/v1/nftdetails', {
                
                  headers: {
                  'X-Api-Token': sessionStorage.getItem("traceChainAccessToken")
                  },
                  
  
              })
              .then((res) => {
                console.log("in API");
                  console.log("res114",res.data.data.result);
                  const nftResult = res.data.data.result;
                  // console.log(nftResult[0].nft_sale[0].sale_copies);
                  let newArray = nftResult;
                  // nftfilter = newArray;
                  // console.log("filter",nftfilter);
                  
                  
                 
              });
          
       
       
      };

    //   function removeusingSet(arr) {
    //     let outputArray = Array.from(new Set(arr))
    //     return outputArray
        
    // }
   
    const clearFilter = (event) => {
      console.log("In Clear Filters");
      setSelectedValues({ network_type: [], provenanceTemplatePath: [], assetName: [] });
      setSelectedValues1({ network_type: [], assetName: [], assetCategory: [] });
      // Uncheck all filter checkboxes
      document.querySelectorAll('.filter-checkbox').forEach(cb => { cb.checked = false; });
    }


    const fetchassetNfts = async (event) => {

      console.log("in fetch api call")
      console.log("selectedValues435",event);
      console.log("selectedValuetype",event.network_type); 
      console.log("selectedValuespath",event.provenanceTemplatePath);
      console.log("selectedValuesname",event.assetName);
      if(selectedValues == "all"){
        // let selectedValues = "";
        queryParams = new URLSearchParams({"network_type": selectedValues});
        console.log("queryParams",queryParams);
        let keysForDel = [];
        queryParams.forEach((value, key) => {
          console.log("value",value);
          console.log("key",key);
          if (value == "all") {
            keysForDel.push(key);
          }
        });

        keysForDel.forEach(key => {
          queryParams.delete(key);
        });

        console.log("FORALL",queryParams.toString());
        const newvar = queryParams.toString()
        queryParams = newvar
        console.log("afterset",queryParams);
      }
      else if(event.network_type !== undefined)
      {
        const newvar = new URLSearchParams({ "network_type": selectedValues });
        queryParams = newvar
        // const queryParams = new URLSearchParams(selectedValues);
        console.log("FORONE",queryParams);
      }
      // else if(event.target.name == "network_type")
      // {
      //   const newvar = new URLSearchParams({ "network_type": selectedValues});
      //   queryParams1 = newvar
      //   console.log("FORONE",queryParams1);
      // }
      else if(event.provenanceTemplatePath !== undefined)
      {
        console.log("for category");
        const newvar = new URLSearchParams({ "provenanceTemplatePath": selectedValues});
        queryParams = newvar
        console.log("FORONE",queryParams);
        console.log("selected",selectedValues)
        // For AssetName according to Asset Category//
        const newArray = nfts.filter(element => element.provenanceTemplatePath == selectedValues[0]);
        console.log("newArray413",newArray);
        newArray.map((array) => {
         console.log("array.assetName",array.assetName);
         const array1 = array.assetName;
         assetNameArrayTemp.push(array1);
         console.log("assetNameArrayTemp",assetNameArrayTemp);
         const forasset = [...new Set(assetNameArrayTemp)];
         console.log("forasset",forasset);
         arrayforasset.push(forasset);
         console.log("arrayforasset",arrayforasset);
         
        })
        lastelement.push(arrayforasset.slice(-1));
        console.log("lastelement",lastelement);
        lastassetnamearray.push(lastelement[0][0]);
        console.log("lastassetnamearray",lastassetnamearray);
        setassetArray(lastassetnamearray);
        console.log("assetArray",assetArray);
        //End of AssetName according to AssetCategory//
      }  
      else if(event.assetName !== undefined)
      {
        console.log("for asset");
        const newvar = new URLSearchParams({ "assetName": selectedValues});
        queryParams = newvar
        console.log("FORONE",queryParams);
      }
      // else if(event.target.name === "assetType")
      // {
      //   console.log("for asset");
      //   const newvar = new URLSearchParams({ "assetType": selectedValues});
      //   queryParams = newvar
      //   console.log("FORONE",queryParams);
      // }
      // else if(event.target.name == "fixedPrice")
      // {
      //   console.log("for price");
      //   // const newvar2 = parseFloat(selectedValues);
      //   // console.log("newvar2",newvar2);
      //   // console.log("newvar2",typeof(newvar2));
      //   const newvar = new URLSearchParams({ "fixedPrice": selectedValues});
      //   // console.log("newvar",newvar);
      //   // console.log("newvar",typeof(newvar));
      //   // const newvar1 = parseFloat(newvar);
      //   // console.log("Var",newvar1);
      //   // console.log("Var",typeof(newvar1));
      //   queryParams = newvar;
      //   console.log("FORONE",queryParams);
      // }

      try {
        console.log("selectedvalue",selectedValues);
        const queryParams = Object.keys(selectedValues)
          .map((key) => {
            if (selectedValues[key].length > 0) {
              return `${key}=${selectedValues[key].join(',')}`;
            }
            return '';
          })
          .filter(Boolean)
          .join('&');
         const response = await axios.get(config.API_ENDPOINT+'src/v1/nftdetails/nftmarketplace?'+queryParams, {
        headers: {
        'X-Api-Token': sessionStorage.getItem("traceChainAccessToken")
        },
    })
    // .then((res) => {
        const nftResult = response.data.data.result;
        // console.log(nftResult[0].nft_sale[0].sale_copies);
        setNfts(nftResult);
    // });
  }catch (error) {
    console.error('Error fetching NFTs:', error);
  }
   
  };


  
   
    // const handleCheckboxChange = (event) => {
    //   const value = event.target.value;
    //   const name  = event.target.name;
    //   // Check if the networkType is already selected
    //   const isSelected = selectedValues[name].includes(value);
   
    //   // If selected, remove it; otherwise, add it
    //   const updatedNetworkType = isSelected
    //     ? selectedValues[name].filter((type) => type !== value)
    //     : [...selectedValues[name], value];
   
    //   // Update the state with the new networkType
    //   setSelectedValues({ [name]: updatedNetworkType });
    //   console.log("selectedValue", selectedValues);
    // };
    
  
    
      const handleCheckboxChange = async (event, networkType) => {
        console.log("event checked",event.target.checked);
        // console.log("filterType",filtertype);
        // handleFilterChange();
        console.log("newArrayTemp",newArrayTemp);
        const value = event.target.value;
        const name  = event.target.name;
        console.log("611",name);
        console.log("value",value);
        console.log("event404",event);
        const isSelected = selectedValues.network_type.includes(value);
      // return false;
       
      if (event.target.checked === true) {
        console.log("in if condition");
        setSelectedValues((prevSelectedValues) => ({
          ...prevSelectedValues,
          // [name]: [value],
          [name]:[...prevSelectedValues[name], value],
        }))
      //   if(event.target.name === "network_type"){
      //   setSelectedValues1((prevSelectedValues) => ({
      //     ...prevSelectedValues,
      //     // [name]: [value],
      //     [name]:[...prevSelectedValues[name], value],
      //   }))
      // }
       
          console.log("aftersel", selectedValues);
          // fetchassetNfts(event);
      } else {
        console.log("in else");
      
        setSelectedValues((prevSelectedValues) => ({
          ...prevSelectedValues,
          [name]: prevSelectedValues[name].filter((val) => val !== value),
        }))
          console.log("aftersel", selectedValues);
          // fetchassetNfts(event);
        
      }
      

    }

    const fetcheprNfts = async (event) => { 
      
      if(selectedValues1 == "all"){
        // let selectedValues = "";
        queryParams1 = new URLSearchParams({"network_type": selectedValues1});
        console.log("queryParams",queryParams1);
        let keysForDel = [];
        queryParams1.forEach((value, key) => {
          console.log("value",value);
          console.log("key",key);
          if (value == "all") {
            keysForDel.push(key);
          }
        });

        keysForDel.forEach(key => {
          queryParams1.delete(key);
        });

        console.log("FORALL",queryParams1.toString());
        const newvar = queryParams1.toString()
        queryParams1 = newvar
        console.log("afterset",queryParams1);
      }
      
      else if(event.network_type !== undefined)
      {
        const newvar = new URLSearchParams({ "network_type": selectedValues1});
        queryParams1 = newvar
        console.log("FORONE",queryParams1);
      }

      else if(event.assetName !== undefined)
        {
          console.log("for asset");
          const newvar = new URLSearchParams({ "assetName": selectedValues1});
          queryParams1 = newvar
          console.log("FORONE",queryParams1);
        }

        else if(event.assetCategory !== undefined)
        {
          console.log("for asset");
          const newvar = new URLSearchParams({ "assetCategory": selectedValues1});
          queryParams1 = newvar
          console.log("FORONE",queryParams1);
        }

        // else if(event.target.name === "assetType")
        // {
        //   console.log("for asset");
        //   const newvar = new URLSearchParams({ "assetType": selectedValues1});
        //   queryParams1 = newvar
        //   console.log("FORONE",queryParams1);
        // }

      try {
      const queryParams1 = Object.entries(selectedValues1)
      .map(([key, values]) => {
        if (values.length > 0) {
          return `${key}=${values.join(',')}`;
        }
        return '';
      
      })
          .filter(Boolean)
          .join('&');
  
  const response = await axios.get(config.API_ENDPOINT+'src/v1/eprnftdetails/eprnftmarketplace?'+queryParams1, {
    headers: {
    'X-Api-Token': sessionStorage.getItem("traceChainAccessToken")
    },
})
// .then((res) => {
    const EprnftResult = response.data.data.result;
    // console.log(nftResult[0].nft_sale[0].sale_copies);
    setEPRNfts(EprnftResult);
// });
      }
catch (error) {
console.error('Error fetching NFTs:', error);
}

}

     

    const handleCheckboxChangeEPR = async (event) => {
      // console.log("filterType",filtertype);
      // handleFilterChange();
      console.log("newArrayTemp",newArrayTemp);
      const value = event.target.value;
      const name = event.target.name;
      console.log("name610",name);
      console.log("value",value);
      console.log("event404",event);
      
      if (event.target.checked === true) {
        console.log("in if condition");
        setSelectedValues1((prevSelectedValues) => ({
          ...prevSelectedValues,
          // [name]: [value],
          [name]:[...prevSelectedValues[name], value],
        }))
       
          console.log("aftersel", selectedValues1);
          // fetchassetNfts(event);
      } else {
        console.log("in else");
      
        setSelectedValues1((prevSelectedValues) => ({
          ...prevSelectedValues,
          [name]: prevSelectedValues[name].filter((val) => val !== value),
        }))
          console.log("aftersel", selectedValues1);
          // fetchassetNfts(event);
        
      }

};



    useEffect(() => {
      console.log("Updated selectedValues:", selectedValues);
      // Call your side effect function here
      fetchassetNfts(selectedValues);// Assuming fetchassetNfts takes the updated values
      fetcheprNfts(selectedValues1);
    }, [selectedValues,selectedValues1]);
      
   
    
    

   

    return(
  <>

    <div className="row my-4 py-4 toppadding">

            {/* ══ FILTER SIDEBAR ══════════════════════════════════════════ */}
            <div className={`col-12 ${sidebarCollapsed ? 'col-lg-1' : 'col-lg-2'} filtercol`}>
              <div className={`sidebar-container ${sidebarCollapsed ? 'is-collapsed' : 'is-expanded'}`}>

                {/* ── Icon Rail (collapsed mode only) ── */}
                {sidebarCollapsed && (
                  <div className="sidebar-icon-rail">

                    {/* Toggle expand button */}
                    <button className="sidebar-toggle-btn" onClick={() => setSidebarCollapsed(false)} title="Expand Filters">
                      <MdChevronRight />
                    </button>

                    <div className="icon-group-label epr-group-icon-label">EPR</div>

                    {/* EPR Platforms */}
                    <div className="sidebar-icon-item">
                      <i className="fab fa-ethereum"></i>
                      <div className="icon-submenu epr-submenu">
                        <div className="submenu-title"><i className="fab fa-ethereum"></i>&nbsp; EPR Platforms</div>
                        {EPRnetworkFilterArray[0]?.map((filtersnetwork) => (
                          <div key={filtersnetwork} className="submenu-option">
                            <label>
                              <input name="network_type" type="checkbox" value={filtersnetwork} onChange={handleCheckboxChangeEPR} />&nbsp;&nbsp;
                              <span>{filtersnetwork}</span>
                            </label>
                          </div>
                        ))}
                      </div>
                    </div>

                    {/* EPR NFT */}
                    <div className="sidebar-icon-item">
                      <i className="fas fa-coins"></i>
                      <div className="icon-submenu epr-submenu">
                        <div className="submenu-title"><i className="fas fa-coins"></i>&nbsp; EPR NFT</div>
                        {EPRassetnamefilterArray[0]?.map((epr) => (
                          <div key={epr} className="submenu-option">
                            <label>
                              <input name="assetName" type="checkbox" value={epr} onChange={handleCheckboxChangeEPR} />&nbsp;&nbsp;
                              <span>{epr}</span>
                            </label>
                          </div>
                        ))}
                      </div>
                    </div>

                    {/* EPR Category */}
                    <div className="sidebar-icon-item">
                      <i className="fas fa-archive"></i>
                      <div className="icon-submenu epr-submenu">
                        <div className="submenu-title"><i className="fas fa-archive"></i>&nbsp; EPR Category</div>
                        {EPRassetcategoryfilterArray[0]?.map((eprcategory) => (
                          <div key={eprcategory} className="submenu-option">
                            <label>
                              <input name="assetCategory" type="checkbox" value={eprcategory} onChange={handleCheckboxChangeEPR} />&nbsp;&nbsp;
                              <span>{eprcategory}</span>
                            </label>
                          </div>
                        ))}
                      </div>
                    </div>

                    <div className="icon-rail-sep"></div>
                    <div className="icon-group-label std-group-icon-label">STD</div>

                    {/* Platforms */}
                    <div className="sidebar-icon-item">
                      <i className="fab fa-ethereum"></i>
                      <div className="icon-submenu std-submenu">
                        <div className="submenu-title"><i className="fab fa-ethereum"></i>&nbsp; Platforms</div>
                        {networkFilterArray[0]?.map((filtersnetwork) => (
                          <div key={filtersnetwork} className="submenu-option">
                            <label>
                              <input name="network_type" type="checkbox" value={filtersnetwork} onChange={handleCheckboxChange} />&nbsp;&nbsp;
                              <span>{filtersnetwork}</span>
                            </label>
                          </div>
                        ))}
                      </div>
                    </div>

                    {/* NFT */}
                    <div className="sidebar-icon-item">
                      <i className="fas fa-coins"></i>
                      <div className="icon-submenu std-submenu">
                        <div className="submenu-title"><i className="fas fa-coins"></i>&nbsp; NFT</div>
                        {assetFilterArray[0]?.map((nonepr) => (
                          <div key={nonepr} className="submenu-option">
                            <label>
                              <input name="assetName" type="checkbox" value={nonepr} onChange={handleCheckboxChange} />&nbsp;&nbsp;
                              <span>{nonepr}</span>
                            </label>
                          </div>
                        ))}
                      </div>
                    </div>

                    {/* Asset Category */}
                    <div className="sidebar-icon-item">
                      <i className="fas fa-archive"></i>
                      <div className="icon-submenu std-submenu">
                        <div className="submenu-title"><i className="fas fa-archive"></i>&nbsp; Asset Category</div>
                        {categoryFilterArray[0]?.map((filterscategory) => (
                          <div key={filterscategory} className="submenu-option">
                            <label>
                              <input name="provenanceTemplatePath" type="checkbox" value={filterscategory} onChange={handleCheckboxChange} />&nbsp;&nbsp;
                              <span>{filterscategory}</span>
                            </label>
                          </div>
                        ))}
                      </div>
                    </div>

                  </div>
                )}

                {/* ── Full Filter Panel (expanded mode) ── */}
                <div className="sidebar-full-panel">
                  {/* Header */}
                  <div className="filter-panel-header">
                    <label style={{ fontWeight: "normal", margin: 0 }}>
                      <b style={{ fontSize: "18px", color: "#001F60" }}>Filters</b>
                    </label>
                    <div className="filter-header-actions">
                      <button className="clearbutton" onClick={clearFilter}>Clear</button>
                      {!sidebarCollapsed && (
                        <button className="sidebar-collapse-btn" onClick={() => setSidebarCollapsed(true)} title="Collapse sidebar">
                          <MdChevronLeft />
                        </button>
                      )}
                    </div>
                  </div>
                  <hr style={{ margin: "0 0 4px 0" }} />

                  {/* Accordion */}
                  <div class="accordion accordion-flush" id="accordionFlushExample">

                  <div class="accordion-item">
                    <h2 class="accordion-header" id="flush-headingTwo">
                      <button class="accordion-button collapsed accordianbuttonstyle" type="button" data-bs-toggle="collapse" data-bs-target="#EPRPLATFORMS" aria-expanded="false" aria-controls="EPRPLATFORMS">
                      <i class='fab fa-ethereum'></i>&nbsp;EPR PLATFORMS
                      </button>
                    </h2>
                    <div id="EPRPLATFORMS" class="accordion-collapse collapse" aria-labelledby="flush-headingTwo" data-bs-parent="#accordionFlushExample">
                      <div class="accordion-body accordionbody">
                      {EPRnetworkFilterArray[0]?.map((filtersnetwork, index) => {
                        return (
                        <div key={filtersnetwork} className = "divvaluestyle">
                              <label>
                                <input name="network_type" type="checkbox" value={filtersnetwork} onChange={handleCheckboxChangeEPR} />&nbsp;&nbsp;
                                <span>{filtersnetwork}</span>
                              </label>
                            </div>
                          )
                      })}
                      </div>
                    </div>
                  </div>

                  <div class="accordion-item">
                    <h2 class="accordion-header" id="flush-headingFour">
                      <button class="accordion-button collapsed accordianbuttonstyle" type="button" data-bs-toggle="collapse" data-bs-target="#EPRNFTs" aria-expanded="false" aria-controls="EPRNFTs">
                      <i class="fas fa-coins"></i>&nbsp;EPR NFT
                      </button>
                    </h2>
                    <div id="EPRNFTs" class="accordion-collapse collapse" aria-labelledby="flush-headingFour" data-bs-parent="#accordionFlushExample">
                      <div class="accordion-body accordionbody">
                      {EPRassetnamefilterArray[0]?.map((epr, index) => (
                        <div key={epr} className = "divvaluestyle">
                          <label>
                            <input name="assetName" type="checkbox" value={epr} onChange={handleCheckboxChangeEPR} />&nbsp;&nbsp;
                            <span>{epr}</span>
                          </label>
                        </div>
                      ))}
                      </div>
                    </div>
                  </div>

                  <div class="accordion-item">
                    <h2 class="accordion-header" id="flush-headingSix">
                      <button class="accordion-button collapsed accordianbuttonstyle" type="button" data-bs-toggle="collapse" data-bs-target="#EPRCategory" aria-expanded="false" aria-controls="EPRCategory">
                      <i class="fas fa-archive"></i>&nbsp;EPR ASSETCATEGORY
                      </button>
                    </h2>
                    <div id="EPRCategory" class="accordion-collapse collapse" aria-labelledby="flush-headingSix" data-bs-parent="#accordionFlushExample">
                      <div class="accordion-body accordionbody">
                      {EPRassetcategoryfilterArray[0]?.map((eprcategory, index) => {
                        console.log("EPRassetcategoryfilterArray[0]", EPRassetcategoryfilterArray[0]);
                        return (
                          <div key={eprcategory} className = "divvaluestyle">
                            <label>
                              <input name="assetCategory" type="checkbox" value={eprcategory} onChange={handleCheckboxChangeEPR} />&nbsp;&nbsp;
                              <span>{eprcategory}</span>
                            </label>
                          </div>
                        );
                      })}
                      </div>
                    </div>
                  </div>

                  <div class="accordion-item">
                    <h2 class="accordion-header" id="flush-headingOne">
                      <button class="accordion-button collapsed accordianbuttonstyle" type="button" data-bs-toggle="collapse" data-bs-target="#PlatformAccordion" aria-expanded="false" aria-controls="PlatformAccordion">
                      <i class='fab fa-ethereum'></i>&nbsp;PLATFORMS
                      </button>
                    </h2>
                    <div id="PlatformAccordion" class="accordion-collapse collapse" aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushExample">
                      <div class="accordion-body accordionbody">
                      {networkFilterArray[0]?.map((filtersnetwork, index) => (
                        <div key={filtersnetwork} className = "divvaluestyle">
                          <label>
                            <input name="network_type" type="checkbox" value={filtersnetwork} onChange={handleCheckboxChange} />&nbsp;&nbsp;
                            <span>{filtersnetwork}</span>
                          </label>
                        </div>
                      ))}
                      </div>
                    </div>
                  </div>

                  <div class="accordion-item">
                    <h2 class="accordion-header" id="flush-headingFive">
                      <button class="accordion-button collapsed accordianbuttonstyle" type="button" data-bs-toggle="collapse" data-bs-target="#NONEPRNFTs" aria-expanded="false" aria-controls="NONEPRNFTs">
                      <i class="fas fa-coins"></i>&nbsp;NFT
                      </button>
                    </h2>
                    <div id="NONEPRNFTs" class="accordion-collapse collapse" aria-labelledby="flush-headingFive" data-bs-parent="#accordionFlushExample">
                      <div class="accordion-body accordionbody">
                      {assetFilterArray[0]?.map((nonepr, index) => (
                        <div key={nonepr} className = "divvaluestyle">
                          <label>
                            <input name="assetName" type="checkbox" value={nonepr} onChange={handleCheckboxChange} />&nbsp;&nbsp;
                            <span>{nonepr}</span>
                          </label>
                        </div>
                      ))}
                      </div>
                    </div>
                  </div>

                  <div class="accordion-item" style={{paddingBottom: "0px"}}>
                    <h2 class="accordion-header" id="flush-headingThree">
                      <button class="accordion-button collapsed accordianbuttonstyle" type="button" data-bs-toggle="collapse" data-bs-target="#ASSETCATEGORY" aria-expanded="false" aria-controls="ASSETCATEGORY">
                      <i class="fas fa-archive"></i>&nbsp;ASSET CATEGORY
                      </button>
                    </h2>
                    <div id="ASSETCATEGORY" class="accordion-collapse collapse" aria-labelledby="flush-headingThree" data-bs-parent="#accordionFlushExample">
                      <div class="accordion-body accordionbody">
                      {categoryFilterArray[0]?.map((filterscategory, index) => {
                        console.log("713 Category", filterscategory);
                        return (
                          <div key={filterscategory} className = "divvaluestyle">
                            <label>
                              <input name="provenanceTemplatePath" type="checkbox" value={filterscategory} onChange={handleCheckboxChange} />&nbsp;&nbsp;
                              <span>{filterscategory}</span>
                            </label>
                          </div>
                        );
                      })}
                      </div>
                    </div>
                  </div>

                  </div>{/* end accordion */}
                </div>{/* end sidebar-full-panel */}

              </div>{/* end sidebar-container */}
            </div>{/* end filtercol */}

            <div className={`col-12 ${sidebarCollapsed ? 'content-col-collapsed' : 'col-lg-10'}`}>
            <div className="row">

           
                    
            <button className="assetrowbutton mb-2">EPR ASSETS ON-SALE</button>
            <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-3 mb-4">
            
            {/* ({EPRnfts}) */}
            {EPRnfts.map((nft) => {
                        console.log("eprnfts1022",EPRnfts);
                        console.log("newapi",nft);
                        const certNumber = nft.certNumber;
                        console.log("certNumber",certNumber);
                        const techNames = certNumber.split("/")[1]
                        console.log("techNames",techNames);
                        return nft.nft_sale.map((nftcopy1) => {
                          console.log("owner0",nft.nft_sale[0].ownerName);
                        console.log("nftcopy1",nftcopy1);
                        console.log("length",nftcopy1.sale_copies.length > 0);
                        console.log("nftcopy1.owner",nftcopy1.owner);
                        if (nftcopy1.sale_copies > 0 && nftcopy1.fixedPrice != null && matchesSearch(nft, nftcopy1, props.searchQuery)) {
                          console.log("nftcopy1._id}",nftcopy1._id);
                          console.log("nftcopy1.asset}",nft.assetName);
                            return (
                                <div className="col-3">
                                    <Card
                                        key={nftcopy1._id}
                                        ownerName = {nft.nft_sale[0].ownerName || techNames}
                                        assetType = "EPRAsset"
                                        owner = {nftcopy1.owner}
                                        totalcopy = {nft.no_of_copies}
                                        UOM = {nft.eprAssetUom}
                                        quantity = {nftcopy1.ownedCopies}
                                        saleCopy = {nftcopy1.sale_copies}
                                        price={nftcopy1.fixedPrice}
                                        image_link={nft.assetImg}
                                        desc="{nft.normalized_metadata.name}"
                                        token_id={nft.tokenId}
                                        name={nft.assetName}
                                        assetId={nft.assetId}
                                        token_address={nft.token_address}
                                        network_type={nft.network_type} 
                                        />
                                </div>
                              
                                
                            );
                            

                            
                        }
                      })


                    })}
                    
                    


            </div>

               {/* ****************Asset On Sale******************** */}

               <button className="assetrowbutton mb-2">ASSETS ON-SALE</button>

            <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-3 mb-4">
                    {nfts.map((nft) => {
                        console.log("nfts976",nfts);
                        console.log("nftmapping",nft);
                        console.log("nftmappingsale",nft.nft_sale);
                        return nft.nft_sale.map((nftcopy1) => {
                        console.log("nftcopy1",nftcopy1);
                        console.log("length",nftcopy1.sale_copies.length > 0);
                        if (nftcopy1.sale_copies > 0 && nftcopy1.fixedPrice != null && matchesSearch(nft, nftcopy1, props.searchQuery)) {
                          console.log("nftcopy1._id}",nftcopy1._id);
                          console.log("nftcopy1.asset}",nft.assetName);
                            return (
                                // <div className="col-3">
                                <div className="col-3">
                                  
                                  
                                {/* <div className="col-lg-3 col-md-6 col-sm-12"> */}
                                    <Card
                                        key={nftcopy1._id}
                                        ownerName = {nftcopy1.ownerName}
                                        assetType = "NonEprAsset"
                                        owner = {nftcopy1.owner}
                                        totalcopy = {nft.no_of_copies}
                                        UOM = {nft.eprAssetUom}
                                        quantity = {nftcopy1.ownedCopies}
                                        saleCopy = {nftcopy1.sale_copies}
                                        price={nftcopy1.fixedPrice}
                                        image_link={nft.assetImg}
                                        desc="{nft.normalized_metadata.name}"
                                        token_id={nft.tokenId}
                                        name={nft.assetName}
                                        assetId={nft.assetId}
                                        token_address={nft.token_address}
                                        network_type={nft.network_type} 
                                        />
                                </div>
                              
                                
                            );
                            

                            
                        }
                      })
                    


                    })}
                    </div>
                    {/* ****************Asset On Sale******************** */}

                    {/* <div className="col-12"> */}
                
            </div>


                
          
                
              
          
          
            </div>

    </div> 
    
  </>
      
       
        
       
    )
  // })}         
}

export default Rows;

